import logo from '../../assets/logo-icon.png';
import { useCode } from '@/hooks/use-code';
import { useShop } from '@/hooks/queries/use-shop';

interface HeaderProps {
  variant: 'default' | 'v2' | 'v3';
}

function Header({ variant }: HeaderProps) {
  const code = useCode();
  const { data: shop } = useShop(code);
  const { user, group } = shop;

  return (
    <header
      className={`sticky top-0 before:absolute before:inset-0 before:backdrop-blur-md max-lg:before:bg-white/90 dark:max-lg:before:bg-gray-800/90 before:-z-10 z-30 ${
        variant === 'v2' || variant === 'v3'
          ? 'before:bg-white after:absolute after:h-px after:inset-x-0 after:top-full after:bg-gray-200 dark:after:bg-gray-700/60 after:-z-10'
          : 'max-lg:shadow-sm lg:before:bg-gray-100/90 dark:lg:before:bg-gray-900/90'
      } ${variant === 'v2' ? 'dark:before:bg-gray-800' : ''} ${variant === 'v3' ? 'dark:before:bg-gray-900' : ''}`}
    >
      <div className="px-4 sm:px-6 lg:px-8">
        <div
          className={`flex items-center justify-between h-16 ${
            variant === 'v2' || variant === 'v3' ? '' : 'lg:border-b border-gray-200 dark:border-gray-700/60'
          }`}
        >
          {/* Header: Left side */}
          <div className="flex items-center gap-4">
            <img src={logo} alt="Piggo" width="52" height="40" />
            <hr className="w-px h-8 bg-gray-200 dark:bg-gray-700/60 border-none" />
            <div className="flex flex-col text-sm md:flex-row md:text-base">
              <div>{group.name}</div>
              <div className="hidden md:block mx-2">/</div>
              <div>{user.name}</div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
